<template>
  <SectionMushroomNewBuilderHeader />
  <SectionMushroomNewBuilderHero />
  <SectionMushroomNewBuilderTestimonial />
  <SectionMushroomNewBuilderLogoSwiper />
  <SectionMushroomNewBuilderDescriptionWithIcons />
  <SectionMushroomNewBuilderContentWithLeftImages />
  <SectionMushroomNewBuilderIconsWithImagesSwiper />
  <SectionMushroomNewBuilderTitleDescriptionIcons />
  <SectionMushroomSpecialTitleDescriptionsPrice :subscriptionOverlay="false" />
  <SectionMushroomNewBuilderTableWithCheckbox />
  <SectionMushroomNewBuilderFrequentlyQuestions />
  <SectionMushroomNewBuilderReviews />
  <SectionLifeboostLatteBuilderFDA />
  <SectionMushroomNewBuilderFooter />
</template>

<script setup>
useSeoMeta({
  layout: () => "default",
  title: () => "Mushroom",
  description: () => "Discover Lifeboost Cognition Coffee, a unique blend of organic, low-acid coffee infused with Lion's Mane and Chaga mushrooms. This combination is designed to enhance focus, mental clarity, and overall well-being. Enjoy clean, jitter-free energy with every cup. Special discounts and subscription options available.",
})

useHead({
  htmlAttrs: {
    class: 'page-real-mushroom-coffee'
  },
  bodyAttrs: {
    class: 'page-real-mushroom-coffee'
  }
})

</script>
<style lang="postcss">
html {
  @apply 2xl:text-base xl:text-15 lg:text-sm md:text-sm sm:text-base text-12
}

body {
  font-size: 17px;
  font-family: 'wigrum-medium';
}
</style>